<template>
<div class="help">
    <el-dialog title="" :visible.sync="totalhelp" :modal="false" class="totaldialog">
        <h1 class="mt-0">一键涂抹，快速抠图</h1>
        <p><span class="num">1</span>上传一张图片</p>
        <p class="p1"><span class="num">2</span>请用"涂抹"工具，完整涂抹需要的图片内容，以缩小抠图范围</p>
        <div class="total pl36"><img src="../../assets/image/dialog/normalcut.png"></div>
            <p class="p2"><span class="num">3</span>直接下载/使用该图片</p>

            <h1 class="mt-48">涂画几笔，精细抠图</h1>

            <p class="p2"><span class="num">a</span>精修大范围：删除使用 <i class="iconfont icon-del f-r"></i> "<span class="f-r">剔除</span>"工具，修复使用 <i class="iconfont icon-save f-b"></i> "<span class="f-b">保留</span>"工具</p>
            <p class="p4"><span class="num">b</span>精修小范围：删除使用 <i class="iconfont icon-eraser f-r"></i> "<span class="f-r">橡皮擦</span>"工具，修复使用 <i class="iconfont icon-repair f-b"></i> "<span class="f-b">修复擦</span>"工具</p>
            <div class="pl36"><img src="../../assets/image/dialog/total.gif" class="gifimg"></div>
                <h1 class="mt-48">期待您的加入</h1>
                <p class="p2">加入我们的抠图社群，学习他人的抠图技巧，反馈您的问题及需求</p>

            <div class="qrcode">
                <div>

                <img src="../../assets/image/connectcode/wx.png"/>
                <p>微信</p>
                </div>
                <div>

                 <img src="../../assets/image/connectcode/dingding.png"/>
                <p>钉钉</p>
                </div>
                
            </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="normalhelp" :show-close="false" :modal="false" class="normaldialog">
        <p>请先用“涂抹工具”完整涂抹需要的图片内容，以缩小抠图范围。</p>
        <div class="mormal"><img src="../../assets/image/dialog/normalcut.png"></div>
            <div class="btn">

                <el-button @click="normalhelp=false">去涂抹</el-button>
            </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="error" :show-close="false" :modal="false" class="errordialog">
        <div class="errorinfo">
            <div><img src="../../assets/image/dialog/error.png"/></div>
                <p>{{tips}}</p>
            </div>
    </el-dialog>

</div>
</template>

<script>
export default {
    data() {
        return {
            totalhelp: false,
            normalhelp: false,
            tips: "",
            error: false
        }
    },
    mounted() {
        if (localStorage.getItem("dzphflag") === null) {
            this.totalhelp = true;
            localStorage.setItem("dzphflag", true)
        }

    },
    methods: {
        showerror(tips) {
            let that = this;
            this.tips = tips;
            this.error = true;
            // window.setTimeout(() => {
            // that.error = false
            // }, 3000)
        },
        opentotalhelp() {
            this.totalhelp = true
        },
        opennormalhelp() {
            this.normalhelp = true
        }
    }
}
</script>

<style lang="scss" scoped>
.help {
    h1 {
        font-weight: normal;
        font-size: 22px
    }

    .f-r {
        color: #ff214b
    }

    .f-b {
        color: #0763fc
    }

    .p1 {
        margin-top: 12px
    }

    .p2 {
        margin-top: 20px
    }

    .p3 {
        margin-top: 17px;
        font-weight: bold
    }

    .p4 {
        margin-top: 15px
    }

    .pl36 {
        padding-left: 36px
    }

    p {
        color: #666;
        font-size: 16px;
        margin: 0;
        line-height: 1;
    }

    .num {
        background-color: #0763fc;
        color: #fff;
        width: 24px;
        height: 24px;
        display: inline-block;
        border-radius: 24px;
        text-align: center;
        padding-top: 5px;
        box-sizing: border-box;
        margin-right: 10px
    }

    img {
        margin-top: 12px;
        width: 441px;
    }
    .qrcode{
        >div{
            text-align: center;
            display: inline-block
        }
        p{
            width: 150px;
            padding-top: 10px
        }
        img{
            width: 150px;
            height: 150px;
            margin-right: 85px
        }
    }

    .total {
        img {
            width: 452px;
        }
    }

    .btn {
        text-align: center
    }

    .totaldialog {
        .mt-0 {
            margin-top: 0
        }

        .mt-48 {
            margin-top: 48px
        }

        .gifimg {
            margin-top: 20px;
            width: 890px;
        }

    }

    .normaldialog {
        p {
            margin-bottom: 20px
        }

        .mormal {
            img {
                width: 620px;
            }
        }

        .el-button {
            margin: 0 auto;
            color: #fff;
            font-size: 18px;
            padding: 18px;
            border: none;
            background-color: #0763fc;
            width: 171px;
            margin-top: 40px
        }
    }

    .errordialog {
        img {
            width: 32px;
            margin-right: 10px;
            margin-top: auto;
        }

        .errorinfo {
            align-items: center;
            display: flex;
            justify-content: center;

            p {
                font-size: 14px;
            }
        }
    }

}
</style>
